export const userAgent = navigator?.userAgent ?? 'service';
export const isBot = userAgent === 'service' || /bot|crawler|spider|crawling/i.test(userAgent);
